import React, { memo, useState, useCallback, Dispatch, SetStateAction } from "react";
import styles from "./SlideFullScreenPage.module.css";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { FilePreviewImage } from "../../../models/slides";

/**
|--------------------------------------------------
| スライド再生画面（全体表示）
|--------------------------------------------------
*/

interface PageFullScreenViewProps {
    pageNumber: number;
    setPageNumber: Dispatch<SetStateAction<any>>;
    currentFilePreviewImage: FilePreviewImage[];
}

function SlideFullScreenPage({
    pageNumber,
    setPageNumber,
    currentFilePreviewImage,
}: PageFullScreenViewProps) {
    // 全画面表示する
    const handle = useFullScreenHandle();
    const [isFullScreen, setFullScreen] = useState(false);

    const handleFullScreenChange = useCallback((state) => {
        setFullScreen(state);
        // eslint-disable-next-line
    }, []);

    // 選択ページを1ページ前に設定
    function handleClickPreviousPage() {
        if (currentFilePreviewImage.length > 0) {
            if (pageNumber > 1) {
                setPageNumber(pageNumber - 1);
            }
        }
    }
    // 選択ページを1ページ前に設定
    function handleClickNextPage() {
        if (currentFilePreviewImage.length > 0) {
            if (pageNumber !== currentFilePreviewImage.length) {
                setPageNumber(pageNumber + 1);
            }
        }
    }

    return (
        <>
            {/* 全画面表示エリア */}
            <img
                src={require("../../../assets/image/full_screen.svg").default}
                onMouseOver={(e) =>
                    (e.currentTarget.src =
                        require("../../../assets/image/full screen_hover_toggle.svg").default)
                }
                onMouseOut={(e) =>
                    (e.currentTarget.src = require("../../../assets/image/full_screen.svg").default)
                }
                alt="fullScreenIcon"
                className={styles.fullScreeNButton}
                onClick={handle.enter}
            />
            {/* プレビューエリア */}
            <div style={{ display: isFullScreen ? "block" : "none" }}>
                <FullScreen handle={handle} onChange={handleFullScreenChange}>
                    {/* 全体表示枠 */}
                    <div className={styles.pageDiv}>
                        {currentFilePreviewImage.length > 0 && (
                            //スライド枠
                            <div className={styles.fileDiv}>
                                {/* 現在表示ファイルの枠 */}
                                <div className={styles.pagePreview}>
                                    {/* 前のページ */}
                                    {pageNumber !== 1 && (
                                        <ArrowBackIcon
                                            className={styles.leftArrow}
                                            onClick={handleClickPreviousPage}
                                        />
                                    )}
                                    {/* 現在表示ページ */}
                                    <div className={styles.pageArea}>
                                        {currentFilePreviewImage.length > 0 && (
                                            <img
                                                src={
                                                    currentFilePreviewImage[pageNumber - 1]
                                                        ?.imageUrl
                                                }
                                                className={styles.pagePosition}
                                                alt=""
                                            />
                                        )}
                                    </div>
                                    {/* 次のページ */}
                                    {pageNumber !== currentFilePreviewImage.length && (
                                        <ArrowForwardIcon
                                            className={styles.rightArrow}
                                            onClick={handleClickNextPage}
                                        />
                                    )}
                                    {/* FullScreen解除ボタン */}
                                    <FullscreenExitIcon
                                        className={styles.fullScreenExit}
                                        onClick={handle.exit}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </FullScreen>
            </div>
        </>
    );
}
export default memo(SlideFullScreenPage);
